import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-benefits-of-merchant-fold',
    templateUrl: './benefits-of-merchant-fold.component.html',
    styleUrls: ['./benefits-of-merchant-fold.component.scss'],
    standalone: false
})
export class BenefitsOfMerchantFoldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
